import { Icon } from '@/new/components/icon';

export const DocViewerLoader = () => {
  return (
    <div className="flex h-full items-center justify-center">
      <Icon className="lucide--loader animate-spin ease-in-out" />
    </div>
  );
};
